import React from "react";
import PropTypes from "prop-types";
import { change } from "redux-form";
import { connect } from "react-redux";
import * as actions from "MODULES/Lots/actions";
import { form, Form as AppForm } from "MODULES/shared/components/Forms";
import CompanyAddressWarning from "MODULES/shared/components/CompanyAddressWarning";
import { PAYMENT_TERMS } from "APP_ROOT/constants";
import DetailFields from "MODULES/Lots/shared/DetailFields/DetailFields";
import validate from "./validate";

const formName = "editLot";

export class Form extends React.Component {
  state = {
    contacts: []
  };

  setPaymentTerms = val => {
    this.props.setLot(val);
  };

  notifyForm = company => this.setState({ company });

  render() {
    const { lot } = this.props;
    const { company } = this.state;

    return (
      <AppForm {...this.props}>
        <AppForm.Body>
          <CompanyAddressWarning company={company} />
          <DetailFields
            lot={lot}
            selectedBuyer={lot.buyer}
            selectedCoBuyer={lot.co_buyer}
            selectedThirdBuyer={lot.third_buyer}
            setSelectedCompany={this.notifyForm}
            setPaymentTerms={this.setPaymentTerms}
            formName={formName}
            setPrimaryContact={false}
          />
        </AppForm.Body>
      </AppForm>
    );
  }
}

Form.propTypes = {
  setLot: PropTypes.func,
  lot: PropTypes.instanceOf(Object)
};

export default connect(undefined, dispatch => ({
  onSubmit: data => dispatch(actions.update(data)),
  setLot: val => dispatch(change(formName, PAYMENT_TERMS, val))
}))(
  form({
    form: formName,
    validate
  })(Form)
);



// WEBPACK FOOTER //
// ./app/modules/Lots/Detail/Edit/EditVendor/Form.jsx